import React from 'react';
import { ProductPageModel } from '../../Types/ProductPageModel';
import { FieldViewModel } from '../../Types/FieldViewModel';
import Field from './ProductPageSpecification/Field';

const FieldComponent = ({ viewName, name, value }: FieldViewModel) => {
  switch (viewName) {
    case 'Field':
    default:
      return <Field name={name} value={value} />;
  }
};

const ProductPageSpecificationsTab = ({
  productPage,
}: {
  productPage: ProductPageModel;
}) => {
  const fields = productPage.productSpecificationsGroup?.productFields;
  return fields && fields.length > 0 ? (
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="rounded border border-solid border-gray-100">
        {fields?.map((field) => (
          <FieldComponent
            {...field}
            key={field.id + '-field-' + productPage.productItem.id}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default ProductPageSpecificationsTab;
